/** Date-navigator jump helpers — pure, unit-tested. */

/** Parse a YYYY-MM-DD key into a local Date; null when malformed. */
export function parseDateKey(key: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key ?? "");
  if (!match) return null;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  // reject rolled-over values like 2026-02-31
  if (date.getMonth() !== Number(match[2]) - 1 || date.getDate() !== Number(match[3])) return null;
  return date;
}

/** Local YYYY-MM-DD for a Date (same contract as the page's localDateKey). */
export function toDateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

/** Clamp any proposed key into [min, max] (both inclusive, "" = unbounded). */
export function clampDateKey(key: string, min = "", max = ""): string {
  if (!parseDateKey(key)) return max || toDateKey(new Date());
  if (min && key < min) return min;
  if (max && key > max) return max;
  return key;
}
